import axiosInstance from '../axiosInstance';

export const login = async (credentials) => {
  try {
    const response = await axiosInstance.post('/api/auth/login', credentials, {
      withCredentials: true,
    });
    return response.status === 200;
  } catch (error) {
    console.log('Login failed:', error);
    return false;
  }
};

export const logout = async () => {
  try {
    const response = await axiosInstance.get('/api/auth/logout');
    if (response.status === 200) {
      window.location.href = '/login';
    }
  } catch (error) {
    console.log('Logout failed:', error);
    return false;
  }
};

export const getCurrentUser = async () => {
  try {
    const response = await axiosInstance.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/users/me`,
      { withCredentials: true }
    );
    if (response.status === 200) {
      return response.data;
    } else {
      return null;
    }
  } catch (error) {
    return null;
  }
};

export const checkUser = async () => {
  console.log('Checking login status...');
  try {
    const response = await axiosInstance.get(
      // eslint-disable-next-line no-undef
      `${process.env.REACT_APP_SERVER_URL}/api/auth/check`,
      { withCredentials: true }
    );
    if (response.status === 200) {
      console.log('id:', response.data.id);
      return response.data.id;
    } else {
      console.log('id: NUlL');
      return null;
    }
  } catch (error) {
    console.log('Auth check failed:', error);
    return null;
  }
};

export const isAuthenticated = async () => {
  try {
    const check = await checkUser();
    if (check === null) {
      return false;
    } else {
      return true;
    }
  } catch (error) {
    console.log('Error during authentication check:', error);
    return false;
  }
};

export const checkPrivilegeOnResource = async (privilege, resource) => {
  try {
    const userData = await getCurrentUser();
    if (!userData || !userData.user) {
      return false;
    }

    // If user has is_super flag set to 1, grant all privileges
    if (userData.user.is_super === 1) {
      return true;
    }

    if (!userData.allPrivileges) {
      return false;
    }

    return userData.allPrivileges.some(
      (item) =>
        item.Privilege &&
        item.Privilege.name === privilege &&
        item.Privilege.Resource &&
        item.Privilege.Resource.name === resource
    );
  } catch (error) {
    console.error('Error checking privilege:', error);
    return false;
  }
};
